
























































































































































































































































































































































































































































































import { isEmpty } from "lodash";
import moment from "moment";
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import AnamnesisPerawat from "@/components/AsesmenAwalGadar/AnamnesisPerawat.vue";
import KedatanganPasienIgd from "@/components/AsesmenAwalGadar/KedatanganPasienIgd.vue";
import RiwayatObstetri from "@/components/AsesmenAwalGadar/RiwayatObstetri.vue";
import CardRiwayatPenyakitTerdahulu from "@/components/pemeriksaan/rpd/CardRiwayatPenyakitTerdahulu.vue";
import {
	KB_TIDAK_KB,
	kbRiwayatPemakaianOptions,
} from "@/constants/kebidananOptions";
import {
	deriveTriaseSurveyPrimer,
	toTriaseInput,
	triaseLevelToKategoriId,
} from "@/pages/PemeriksaanIgdPage/triaseSurveyPrimer";
// import TandaVital from "@/components/AsesmenAwalGadar/TandaVital.vue";
// import AsesmenLain from "@/components/AsesmenAwalGadar/AsesmenLain.vue";
// import AsesmenNyeri from "@/components/AsesmenAwalGadar/AsesmenNyeri.vue";
import AsesmenAwalGadar from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";
import AsesmenAwalGadarKeperawatan from "@/services/AsesmenAwalGadar/AsesmenAwalGadarKeperawatan";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import RegisterKunjungan, {
	IfcRegister,
} from "@/store/modules/RegisterKunjungan";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import HydrationGuard from "@/mixins/HydrationGuard";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import type { Nyeri, TTV } from "@/types/asesmen";
// import {
//   // AsesmenAwalGadarPerawat,
//   AsesmenAwalGadarPerawatResp
// } from "@/types/asesmen_gawat_darurat_perawat";
// Inline `type` modifier (import { type X }) butuh TS 4.5+ — proyek ini TS 3.8
import { Tensi } from "@/types/asesmen";

@Component({
	components: {
		KedatanganPasienIgd,
		AnamnesisPerawat,
		RiwayatObstetri,
		CardRiwayatPenyakitTerdahulu,
	},
	inject: {
		isReadOnly: { default: () => () => false },
	},
})
export default class AsesmenKeperawatanGadarPage extends Mixins(HydrationGuard) {
	@Prop() readonly register!: number;
	@Prop() readonly rm!: number;
	@Prop({ default: false }) readonly isActive!: boolean;
	isReadOnly!: () => boolean;

	get terkunci(): boolean {
		return this.busy || this.saving;
	}

	get readOnly(): boolean {
		return this.isReadOnly();
	}
	@Ref() readonly refRiwayatAlergi;
	@Ref() readonly dateTimePicker;
	@Ref() readonly refArivalDescription: HTMLInputElement;
	@Ref() readonly refKasusDescription: HTMLInputElement;

	selectProps = { openOnHover: true, offsetY: true };
	saving = false;
	showHphtPicker = false;
	showHplPicker = false;
	maxHphtDate = moment().format("YYYY-MM-DD");
	timePickerProps = { format: "24hr", scrollable: true };
	datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
	todayDate = moment().format("YYYY-MM-DD");

	id = null;

	rules = {
		required: (value) => !!value || "Kolom ini harus terisi",
	};

	isAnyAlergi = false;
	arivedAt = null;
	triage = null;
	showUsiaHamilManual = false;
	arival = null;
	transportasi = null;
	transportasiDescription = null;
	kasus = null;
	arivalDescription = null;
	kasusDescription = null;

	riwayatAlergi = null;
	riwayatObat = null;
	riwayatPenyakitLalu = null;
	riwayatMakanTerakhir = null;
	riwayatLainLain = null;
	riwayatError = false;

	obsRiwayat = null;
	obsG = null;
	obsP = null;
	obsA = null;
	obsAH = null;
	// obsUsiaHamil = null;
	obsHpht = null;
	obsHpl = null;
	obsPalpasiLeo = null;
	obsTfu = null;
	obsTbj = null;
	obsHis = null;
	obsDjj = null;
	obsPanggul = null;
	obsVt = null;
	obsLla = null;
	obsTb = null;
	obsBb = null;
	obsKb = null;
	obsKbDescription = null;
	obsKbJenis: string | null = null;
	obsInterpretasi: string | null = null;
	usiaHamilMg = null;
	usiaHamilHr = null;

	tvSistole = null;
	tvDiastole = null;
	tvNadi = null;
	tvNafas = null;
	tvSuhu = null;
	tvSaturasiO2 = null;
	gcsEye = null;
	gcsVerbal = null;
	gcsMotor = null;
	asesRisjat = null;
	asesKecemasan = null;

	nyeriSkala = 0;
	nyeriLokasi = null;
	nyeriFrekuensi = null;
	nyeriDurasi = null;
	nyeriPencetus = null;
	nyeriKualitas = null;
	nyeriPolaSerangan = null;
	nyeriPenyebabHilang = null;
	nyeriJenis = null;

	perawat = null;

	arivalOptions = [
		{ id: 1, name: "Datang Sendiri" },
		{ id: 2, name: "Diantar" },
		{ id: 3, name: "Rujukan" },
		{ id: 99, name: "Lainnya" },
	];
	transportasiOptions = [
		{ id: 1, name: "Ambulance" },
		{ id: 2, name: "Mobil" },
		{ id: 3, name: "Motor" },
		{ id: 99, name: "Lainnya" },
	];
	kasusOptions = [
		{ id: 0, name: "Non-Trauma" },
		{ id: 1, name: "Trauma" },
		{ id: 2, name: "Obsgyn" },
		{ id: 3, name: "Anak" },
		{ id: 99, name: "Lainnya" },
	];
	triageOptions = [
		{ id: 1, name: "Kategori 1", color: "#B71C1C" },
		{ id: 2, name: "Kategori 2", color: "#EF5350" },
		{ id: 3, name: "Kategori 3", color: "yellow" },
		{ id: 4, name: "Kategori 4", color: "#1B5E20" },
		{ id: 5, name: "Kategori 5", color: "#66BB6A" },
		{ id: 0, name: "Meninggal", color: "black" },
	];
	kbRiwayatOptions = kbRiwayatPemakaianOptions;

	get isUsingKb() {
		return !!this.obsKbJenis && this.obsKbJenis !== KB_TIDAK_KB;
	}

	get showInputPerkiraanUsiaHamil() {
		return (
			isEmpty(this.obsHpht) &&
			(this.showUsiaHamilManual ||
				!isEmpty(this.usiaHamilMg) ||
				!isEmpty(this.usiaHamilHr))
		);
	}

	get usiaKehamilanText() {
		const age = this.obsUsiaHamil;

		const day = age % 7,
			week = (age - day) / 7;

		const dayText = day ? `${day} Hari` : "",
			weekText = week ? `${week} Minggu` : "";

		return [weekText, dayText].join(" ") ?? "-";
	}

	get obsUsiaHamil(): number {
		if (this.obsHpht) {
			const hpht = this.obsHpht
				? new Date(this.obsHpht)
				: new Date(moment().format("YYYY-MM-DD"));
			const diff =
				new Date(moment().format("YYYY-MM-DD")).getTime() - hpht.getTime();

			const age = Math.floor(diff / (1000 * 60 * 60 * 24));

			return age;
		} else if (this.usiaHamilHr || this.usiaHamilMg) {
			const mg = !isEmpty(this.usiaHamilMg) ? this.usiaHamilMg : 0,
				hr = !isEmpty(this.usiaHamilHr) ? this.usiaHamilHr : 0;
			const age = parseInt(mg) * 7 + parseInt(hr);

			return age ?? null;
		}

		return null;
	}

	set obsUsiaHamil(val) {
		if (val) {
			const diffDays = parseInt(val.toString()) % 7;
			this.usiaHamilMg = Math.floor(parseInt(val.toString()) / 7);
			this.usiaHamilHr = diffDays;
		}
	}

	get arivalDescriptionLabel() {
		if (this.arival.id == 2) {
			return "Diantar oleh";
		}

		if (this.arival.id == 3) {
			return "Rujukan dari";
		}

		if (this.arival.id == 99) {
			return "Sebutkan kedatangan lainnya";
		}

		return "Sebutkan";
	}

	get stateUser() {
		return userModule.user;
	}

	kedatanganId = null;
	anamnesisId = null;
	obsId = null;
	asesKesadaranId = null;
	asesKecemasanId = null;
	nyeriId = null;
	asesRisjatId = null;
	ttvId = null;

	get input() {
		return {
			id: this.id,
			pasien_rm: this.rm,
			register_id: this.register,
			unit_id: this.stateUser.unit_id,
			kedatangan: this.isAnyKedatanganInputed
				? {
						id: this.kedatanganId,
						triage_id: this.triage?.id,
						arrived_at: this.formatedArivedAt,
						kedatangan_id: this.arival?.id,
						kedatangan_text: this.arivalDescription,
						transport_id: this.transportasi?.id,
						transport_text: this.transportasiDescription,
						kasus_id: this.kasus?.id,
						kasus_text: this.kasusDescription,
					}
				: null,
			anamnesis: this.isAnyAnamnesisInputed
				? {
						id: this.anamnesisId,
						alergi: this.riwayatAlergi,
						riwayat_obat: this.riwayatObat,
						riwayat_penyakit_sekarang: null,
						riwayat_penyakit_dahulu: this.riwayatPenyakitLalu,
						makan_terakhir: this.riwayatMakanTerakhir,
						lainnya: this.riwayatLainLain,
					}
				: null,
			riwayatObstetri: this.isAnyRiwayatObstetri
				? {
						id: this.obsId,
						riwayat: this.obsRiwayat,
						g: this.obsG,
						p: this.obsP,
						a: this.obsA,
						ah: this.obsAH,
						hpht: this.obsHpht,
						hpl: this.obsHpl,
						usia_hamil: this.obsUsiaHamil,
						palpasi: this.obsPalpasiLeo,
						tfu: this.obsTfu,
						tbj: this.obsTbj,
						his: this.obsHis,
						djj: this.obsDjj,
						panggul: this.obsPanggul,
						vt: this.obsVt,
						lla: this.obsLla,
						tb: this.obsTb,
						bb: this.obsBb,
						kb: this.obsKb?.id,
						kb_description: this.isUsingKb ? this.obsKbDescription : null,
						kb_jenis: this.obsKbJenis,
						interpretasi: this.obsInterpretasi,
						unit_id: this.stateUser.unit_id,
					}
				: null,
			perawat_id: this.perawat,
		};
	}

	get listPerawat() {
		return storePerawat.listPerawat;
	}

	get storeAsesmenPerawat() {
		return AsesmenGadarKeperawatanStore;
	}

	get formatedArivedAt() {
		return this.arivedAt
			? moment(this.arivedAt).format("YYYY-MM-DD HH:mm:ss")
			: null;
	}

	get registerPendaftaran(): IfcRegister | null {
		const reg = RegisterKunjungan.register;

		return reg && String(reg.no) === String(this.register) ? reg : null;
	}

	get waktuPendaftaran(): Date | null {
		const reg = this.registerPendaftaran;

		if (!reg || !reg.tgl) {
			return null;
		}

		const waktu = moment(
			`${reg.tgl} ${reg.jam || "00:00"}`,
			"DD-MM-YYYY HH:mm",
			true,
		);

		return waktu.isValid() ? waktu.toDate() : null;
	}

	get waktuPendaftaranText(): string {
		const waktu = this.waktuPendaftaran;

		return waktu ? moment(waktu).format("DD-MM-YYYY HH:mm") : "";
	}

	get isWaktuKedatanganSamaPendaftaran(): boolean {
		const waktu = this.waktuPendaftaran;

		if (!waktu || !this.arivedAt) {
			return false;
		}

		return (
			moment(this.arivedAt).format("YYYY-MM-DD HH:mm") ===
			moment(waktu).format("YYYY-MM-DD HH:mm")
		);
	}

	samakanWaktuKedatangan() {
		const waktu = this.waktuPendaftaran;

		if (waktu) {
			this.arivedAt = waktu;
		}
	}

	async resolveWaktuPendaftaran(): Promise<Date | null> {
		if (this.waktuPendaftaran) {
			return this.waktuPendaftaran;
		}

		try {
			await RegisterKunjungan.getRegister(this.register);
		} catch {
			return null;
		}

		return this.waktuPendaftaran;
	}

	get pasienAlergi() {
		return storePasien.identitasPasien?.alergi;
	}

	get isAnyRiwayatObstetri() {
		if (
			this.obsId ||
			this.obsRiwayat ||
			this.obsG ||
			this.obsP ||
			this.obsA ||
			this.obsAH ||
			this.obsHpht ||
			this.obsHpl ||
			this.obsUsiaHamil ||
			this.obsPalpasiLeo ||
			this.obsTfu ||
			this.obsTbj ||
			this.obsHis ||
			this.obsDjj ||
			this.obsPanggul ||
			this.obsVt ||
			this.obsLla ||
			this.obsTb ||
			this.obsBb ||
			this.obsInterpretasi ||
			this.obsKb?.id ||
			this.obsKbDescription ||
			this.obsKbJenis
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesRisjatInputed() {
		return this.asesRisjatId || this.asesRisjat !== null ? true : false;
	}

	get isAnyTandaVitalInputed() {
		if (
			this.ttvId ||
			this.tvSistole ||
			this.tvDiastole ||
			this.tvNadi ||
			this.tvNafas ||
			this.tvSuhu ||
			this.tvSaturasiO2
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyKedatanganInputed() {
		if (
			this.kedatanganId ||
			this.triage?.id ||
			this.arival?.id ||
			this.arivalDescription ||
			this.arivalDescription ||
			this.transportasi?.id ||
			this.transportasiDescription ||
			this.kasus?.id ||
			this.kasusDescription
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAnamnesisInputed() {
		if (
			this.anamnesisId ||
			this.riwayatAlergi ||
			this.riwayatObat ||
			this.riwayatPenyakitLalu ||
			this.riwayatMakanTerakhir ||
			this.riwayatLainLain
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesKesadaranInputed() {
		if (
			this.asesKesadaranId ||
			this.gcsEye ||
			this.gcsVerbal ||
			this.gcsMotor
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesKecemasanInputed() {
		if (this.asesKecemasanId || this.asesKecemasan !== null) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesNyeriInputed() {
		if (
			this.nyeriId ||
			this.nyeriSkala ||
			this.nyeriLokasi ||
			this.nyeriFrekuensi ||
			this.nyeriDurasi ||
			this.nyeriPencetus ||
			this.nyeriKualitas ||
			this.nyeriPolaSerangan ||
			this.nyeriPenyebabHilang ||
			this.nyeriJenis
		) {
			return true;
		} else {
			return false;
		}
	}

	@Watch("obsHpht")
	changedHpht(val) {
		console.log("changed hpht", val);
		if (val) {
			const add = moment(val)
				.add(9, "months")
				.add(7, "days")
				.format("YYYY-MM-DD");

			this.obsHpl = add;
			console.log("add hpl", add);
		}
	}

	@Watch("arival")
	changedArival(val) {
		if (val && val.id > 1) {
			this.$nextTick(() => {
				this.refArivalDescription.focus();
			});
		}
	}

	@Watch("kasus")
	changedKasus(val) {
		if (val && val.id == 99) {
			this.$nextTick(() => {
				this.refKasusDescription.focus();
			});
		}
	}

	async mounted() {
		this.getData();
	}

	async save() {
		if (this.readOnly || this.terkunci) return;

		if (!this.triage) {
			appModule.sendErrorAlert(
				"Triase belum bisa ditentukan — lengkapi Survey Primer (ABCDE / tingkat kesadaran) terlebih dahulu.",
			);
			return;
		}

		this.riwayatError = !this.isAnyAnamnesisInputed;

		if (this.riwayatError) {
			return;
		}

		this.saving = true;

		try {
			this.id
				? await AsesmenAwalGadarKeperawatan.update(this.id, this.input)
				: await AsesmenAwalGadarKeperawatan.create(this.input);

			appModule.NoticeDelay("Berhasil Simpan Asesmen Keperawatan");

			await this.getData();

			storePasien.getDataPasien(this.rm);
		} catch (e) {
			//
		} finally {
			this.saving = false;
		}
	}

	remove() {
		const q = confirm("Hapus Asesmen Keperawatan?");

		if (q) {
			this.deleteData();
		}
	}

	async deleteData() {
		const del = await AsesmenAwalGadarKeperawatan.destroy(this.id);

		if (del?.status == 1) {
			appModule.NoticeDelay("Berhasil Hapus Asesmen Keperawatan");

			await this.getData();

			storePasien.getDataPasien(this.rm);
		} else {
			alert("Kesalahan dalam menghapus data...");
		}
	}

	async getData() {
		const reg = this.register;

		await this.hydrate(async () => {
			await this.storeAsesmenPerawat.getByRegister(reg);

			if (reg !== this.register) return;

			const data = this.storeAsesmenPerawat.asesmen;

			if (data) {
				const ctn = data.content;

				this.id = data.id;
				if (ctn.kedatangan) {
					this.kedatanganId = ctn.kedatangan.id;
					this.arivedAt = new Date(ctn.kedatangan.arivedAt);
					const triageId = ctn.kedatangan.triage?.id ?? null;
					this.triage =
						this.triageOptions.find(({ id }) => id === triageId) ?? null;
					this.arival = ctn.kedatangan.arival;
					this.arivalDescription = ctn.kedatangan.arivalDescription;
					this.transportasi = ctn.kedatangan.transportasi;
					this.transportasiDescription = ctn.kedatangan.transportasiDescription;
					this.kasus = ctn.kedatangan.kasus;
					this.kasusDescription = ctn.kedatangan.kasusDescription;
				}

				if (ctn.riwayatKesehatan) {
					this.anamnesisId = ctn.riwayatKesehatan.id;
					this.riwayatAlergi = ctn.riwayatKesehatan.alergi;
					this.riwayatObat = ctn.riwayatKesehatan.obat;
					this.riwayatPenyakitLalu = ctn.riwayatKesehatan.penyakitLalu;
					this.riwayatMakanTerakhir = ctn.riwayatKesehatan.makanTerakhir;
					this.riwayatLainLain = ctn.riwayatKesehatan.lain;
				}

				if (ctn.riwayatObstetri) {
					this.obsId = ctn.riwayatObstetri.id;
					this.obsRiwayat = ctn.riwayatObstetri.riwayat;
					this.obsG = ctn.riwayatObstetri.g;
					this.obsP = ctn.riwayatObstetri.p;
					this.obsA = ctn.riwayatObstetri.a;
					this.obsAH = ctn.riwayatObstetri.ah;
					this.obsHpht = ctn.riwayatObstetri.hpht;
					this.obsHpl = ctn.riwayatObstetri.hpl;
					this.obsUsiaHamil = ctn.riwayatObstetri.usiaHamil;
					this.obsPalpasiLeo = ctn.riwayatObstetri.palpasi;
					this.obsTfu = ctn.riwayatObstetri.tfu;
					this.obsTbj = ctn.riwayatObstetri.tbj;
					this.obsHis = ctn.riwayatObstetri.his;
					this.obsDjj = ctn.riwayatObstetri.djj;
					this.obsPanggul = ctn.riwayatObstetri.panggul;
					this.obsVt = ctn.riwayatObstetri.vt;
					this.obsLla = ctn.riwayatObstetri.lla;
					this.obsTb = ctn.riwayatObstetri.tb;
					this.obsBb = ctn.riwayatObstetri.bb;
					this.obsKb = ctn.riwayatObstetri.kb;
					this.obsKbDescription = ctn.riwayatObstetri.kbDescription;
					this.obsKbJenis = ctn.riwayatObstetri.kbJenis ?? null;
					this.obsInterpretasi = ctn.riwayatObstetri.interpretasi ?? null;
				}

				if (ctn.tanda_vital) {
					this.ttvId = ctn.tanda_vital.id;
					this.tvSistole = ctn.tanda_vital.tensi?.sistole;
					this.tvDiastole = ctn.tanda_vital.tensi?.diastole;
					this.tvNadi = ctn.tanda_vital.nadi;
					this.tvNafas = ctn.tanda_vital.nafas;
					this.tvSuhu = ctn.tanda_vital.suhu;
					this.tvSaturasiO2 = ctn.tanda_vital.saturasi;
				}

				if (ctn.nyeri) {
					this.nyeriId = ctn.nyeri.id;
					this.nyeriSkala = ctn.nyeri.skala;
					this.nyeriLokasi = ctn.nyeri.lokasi;
					this.nyeriFrekuensi = ctn.nyeri.frekuensi;
					this.nyeriDurasi = ctn.nyeri.durasi;
					this.nyeriPencetus = ctn.nyeri.pencetus;
					this.nyeriKualitas = ctn.nyeri.kualitas;
					this.nyeriPolaSerangan = ctn.nyeri.pola_serangan;
					this.nyeriPenyebabHilang = ctn.nyeri.penyebab_hilang;
					this.nyeriJenis = ctn.nyeri.jenis;
				}

				if (ctn.gcs) {
					this.asesKesadaranId = ctn.gcs.id;
					this.gcsEye = ctn.gcs.eye;
					this.gcsVerbal = ctn.gcs.verbal;
					this.gcsMotor = ctn.gcs.motor;
				}

				if (ctn.risiko_jatuh) {
					this.asesRisjatId = ctn.risiko_jatuh.id;
					this.asesRisjat = ctn.risiko_jatuh.risiko;
				}

				if (ctn.kecemasan) {
					this.asesKecemasanId = ctn.kecemasan.id;
					this.asesKecemasan = ctn.kecemasan.level;
				}

				if (ctn.perawat) {
					this.perawat = ctn.perawat.id;
				}

				this.isAnyAlergi = !isEmpty(this.riwayatAlergi) ? true : false;
			} else {
				this.clearInput();

				this.arivedAt = (await this.resolveWaktuPendaftaran()) ?? new Date();

				if (!this.riwayatAlergi && this.pasienAlergi) {
					this.riwayatAlergi = this.pasienAlergi;
					this.isAnyAlergi = true;
				}
			}

			await this.defaultTriageFromSurveyPrimer();
		});
	}

	get surveyPrimerContent() {
		const rec = AsesmenSurveyPrimerGadarStore.asesmen;
		if (!rec || String(rec.register_id) !== String(this.register)) {
			return null;
		}
		return rec.content ?? null;
	}

	@Watch("surveyPrimerContent")
	onSurveyPrimerContentChanged() {
		this.applyTriageFromSurveyPrimer();
	}

	async defaultTriageFromSurveyPrimer() {
		if (!this.surveyPrimerContent) {
			await AsesmenSurveyPrimerGadarStore.getByRegister(this.register);
		}
		this.applyTriageFromSurveyPrimer();
	}

	derivedTriageId(): number | null {
		const ctn = this.surveyPrimerContent;
		if (!ctn) {
			return null;
		}

		const level = deriveTriaseSurveyPrimer(
			toTriaseInput({
				airway: ctn.a_airway,
				pernapasan: ctn.b_pernapasan,
				pernapasanType: ctn.b_pernapasan_type,
				klinis: ctn.b_klinis,
				dada: ctn.b_dada,
				nadi: ctn.c_nadi,
				kulit: ctn.c_kulit,
				akral: ctn.c_akral,
				crt: ctn.c_crt,
				kesadaran: ctn.d_kesadaran,
				pupilReflek: ctn.d_pupil_reflek,
				reflekCahaya: ctn.d_reflek_cahaya,
				eksposur: ctn.e_eksposur,
				isDoa: ctn.is_doa,
			}),
		).level; // "P1" | "P2" | "P3" | "P4" | "DOA" | null

		return triaseLevelToKategoriId(level);
	}

	applyTriageFromSurveyPrimer() {
		if (!this.surveyPrimerContent) {
			return;
		}

		const kategori = this.derivedTriageId();

		this.triage =
			kategori == null
				? null
				: (this.triageOptions.find(({ id }) => id === kategori) ?? null);
	}

	clearInput() {
		this.id = null;

		this.arivedAt = null;
		this.triage = null;
		this.showUsiaHamilManual = false;
		this.arival = null;
		this.transportasi = null;
		this.kasus = null;
		this.arivalDescription = null;
		this.kasusDescription = null;

		this.riwayatAlergi = null;
		this.riwayatObat = null;
		this.riwayatPenyakitLalu = null;
		this.riwayatMakanTerakhir = null;
		this.riwayatLainLain = null;
		this.riwayatError = false;
		this.obsRiwayat = null;
		this.obsG = null;
		this.obsP = null;
		this.obsA = null;
		this.obsAH = null;
		this.obsUsiaHamil = null;
		this.obsHpht = null;
		this.obsHpl = null;
		this.obsPalpasiLeo = null;
		this.obsTfu = null;
		this.obsTbj = null;
		this.obsHis = null;
		this.obsDjj = null;
		this.obsPanggul = null;
		this.obsVt = null;
		this.obsLla = null;
		this.obsTb = null;
		this.obsBb = null;
		this.obsKb = null;
		this.obsKbDescription = null;
		this.obsKbJenis = null;
		this.obsInterpretasi = null;

		this.kedatanganId = null;
		this.anamnesisId = null;
		this.obsId = null;
		this.asesKesadaranId = null;
		this.asesKecemasanId = null;
		this.nyeriId = null;
		this.asesRisjatId = null;
		this.ttvId = null;

		this.tvSistole = null;
		this.tvDiastole = null;
		this.tvNadi = null;
		this.tvNafas = null;
		this.tvSuhu = null;
		this.tvSaturasiO2 = null;
		this.gcsEye = null;
		this.gcsVerbal = null;
		this.gcsMotor = null;
		this.asesRisjat = null;
		this.asesKecemasan = null;

		this.nyeriSkala = 0;
		this.nyeriLokasi = null;
		this.nyeriFrekuensi = null;
		this.nyeriDurasi = null;
		this.nyeriPencetus = null;
		this.nyeriKualitas = null;
		this.nyeriPolaSerangan = null;
		this.nyeriPenyebabHilang = null;
		this.nyeriJenis = null;

		this.$refs.dateTimePicker["clearHandler"]();

		this.perawat = null;
	}

	@Watch("arivedAt")
	changeArivedAt(val) {
		//
	}

	@Watch("isAnyAlergi")
	changeIsAnyAlergi(val) {
		if (val) {
			this.refRiwayatAlergi.focus();
		} else {
			this.riwayatAlergi = "";
		}
	}

	@Watch("isAnyAnamnesisInputed")
	changeIsAnyAnamnesisInputed(val) {
		if (val) {
			this.riwayatError = false;
		}
	}

	printAsesmenAwal() {
		AsesmenAwalGadar.printByRegister(this.register);
	}

	get valNyeri(): Nyeri {
		return {
			skala: this.nyeriSkala,
			lokasi: this.nyeriLokasi,
			frekuensi: this.nyeriFrekuensi,
			durasi: this.nyeriDurasi,
			pencetus: this.nyeriPencetus,
			kualitas: this.nyeriKualitas,
			pola_serangan: this.nyeriPolaSerangan,
			penyebab_hilang: this.nyeriPenyebabHilang,
			jenis: this.nyeriJenis,
		};
	}

	set valNyeri(val) {
		this.nyeriSkala = val.skala;
		this.nyeriLokasi = val.lokasi;
		this.nyeriFrekuensi = val.frekuensi;
		this.nyeriDurasi = val.durasi;
		this.nyeriPencetus = val.pencetus;
		this.nyeriKualitas = val.kualitas;
		this.nyeriPolaSerangan = val.pola_serangan;
		this.nyeriPenyebabHilang = val.penyebab_hilang;
		this.nyeriJenis = val.jenis;
	}

	get valTtv(): TTV {
		return {
			sistole: this.tvSistole,
			diastole: this.tvDiastole,
			nadi: this.tvNadi,
			nafas: this.tvNafas,
			suhu: this.tvSuhu,
			saturasiO2: this.tvSaturasiO2,
		};
	}

	set valTtv(val: TTV) {
		this.tvSistole = val.sistole;
		this.tvDiastole = val.diastole;
		this.tvNadi = val.nadi;
		this.tvNafas = val.nafas;
		this.tvSuhu = val.suhu;
		this.tvSaturasiO2 = val.saturasiO2;
	}

	get gcs() {
		return {
			e: this.gcsEye,
			v: this.gcsVerbal,
			m: this.gcsMotor,
		};
	}

	setNyeri(val: Nyeri) {
		this.valNyeri = val;
	}

	setTtv(val: TTV) {
		this.valTtv = val;
	}

	setGcs(val) {
		this.gcsEye = val.e;
		this.gcsVerbal = val.v;
		this.gcsMotor = val.m;
	}

	setRisikoJatuh(val) {
		this.asesRisjat = val;
	}

	setKecemasan(val) {
		this.asesKecemasan = val;
	}

	dummyData() {
		this.triage = 3;
		this.arival = 2;
		this.transportasi = 0;
		this.arivalDescription = "dengan orang lain";
		this.kasus = 0;
		// this.kasusDescription = "kasus luar biasa";

		// this.riwayatAlergi = "makanan laut";
		this.riwayatObat = "paracetamol 1x3 siang habis makan";
		this.riwayatPenyakitLalu = "hipertensi";
		this.riwayatMakanTerakhir = "tadi siang";
		this.riwayatLainLain = "penyakit lainnya";
		this.obsRiwayat = "hamil ektopik";
		this.obsG = 5;
		this.obsP = 4;
		this.obsA = 1;
		this.obsAH = 3;
		this.obsHpht = "2021-06-01";
		this.obsHpl = "2022-03-10";
		this.obsPalpasiLeo = "palpasi leo";
		this.obsTfu = 30;
		this.obsTbj = 12;
		this.obsHis = 12;
		this.obsDjj = 13;
		this.obsPanggul = 15;
		this.obsVt = 20;
		this.obsLla = 10;
		this.obsTb = 160;
		this.obsBb = 60;
		this.obsKbJenis = "Implant";
		this.obsKbDescription = "susuk";

		this.tvSistole = 110;
		this.tvDiastole = 80;
		this.tvNadi = 36;
		this.tvNafas = 36;
		this.tvSuhu = 36;
		this.tvSaturasiO2 = 90;
		this.gcsEye = 4;
		this.gcsVerbal = 5;
		this.gcsMotor = 6;
		this.asesRisjat = 0;
		this.asesKecemasan = 0;

		this.nyeriSkala = 2;
		this.nyeriLokasi = null;
		this.nyeriFrekuensi = null;
		this.nyeriDurasi = null;
		this.nyeriPencetus = null;
		this.nyeriKualitas = null;
		this.nyeriPolaSerangan = null;
		this.nyeriPenyebabHilang = null;
		this.nyeriJenis = "1";

		this.perawat = 490;
	}
}
